// extracted by mini-css-extract-plugin
export var avatar = "_m8-3";
export var avatarContainer = "_m8-2";
export var avatarSpacer = "_m8-5";
export var avatarSpacerContainer = "_m8-4";
export var avatarStackContainer = "_m8-1";
export var bubble = "_m8-0";
export var remainderBubble = "_m8-6";